import { Rocket, MessagesSquare, LineChart } from "lucide-react";

const steps = [
  {
    n: "01",
    Icon: Rocket,
    title: "Launch a channel",
    body: "Create an always-on anonymous channel for any team in under 60 seconds. Share a link or QR code.",
    tone: "mkt-wash-peach",
  },
  {
    n: "02",
    Icon: MessagesSquare,
    title: "Employees chat (not fill forms)",
    body: "AI Co-pilot interviews employees conversationally — higher quality signal than static surveys.",
    tone: "mkt-wash-lilac",
  },
  {
    n: "03",
    Icon: LineChart,
    title: "Get themes, sentiment, risk",
    body: "Themes cluster automatically. Sentiment is tracked over time. Retention risks surface before exits.",
    tone: "mkt-wash-sky",
  },
];

export const HowItWorks = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 py-12 sm:py-16 lg:py-24" id="how-it-works">
      <div className="text-center max-w-2xl mx-auto mb-8 sm:mb-12">
        <div className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--mkt-primary))] mb-3">
          How it works
        </div>
        <h2 className="text-3xl sm:text-5xl lg:text-[64px] tracking-[-0.03em] leading-[1.05]">
          From zero to <span className="font-display">honest feedback</span> in 5 minutes
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-5">
        {steps.map((s) => {
          const Icon = s.Icon;
          return (
            <div
              key={s.n}
              className="group relative rounded-3xl bg-card border border-border overflow-hidden mkt-shadow-card flex flex-col transition-shadow hover:shadow-card-hover"
            >
              {/* Pastel header block */}
              <div className={`relative ${s.tone} h-36 sm:h-44 flex items-center justify-center`}>
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-card/80 backdrop-blur border border-white/60 text-foreground">
                  <Icon className="h-6 w-6" />
                </span>
                <span className="absolute top-4 left-5 text-[11px] font-semibold tracking-[0.2em] text-foreground/45">
                  STEP {s.n}
                </span>
              </div>

              <div className="p-5 sm:p-7">
                <h3 className="text-xl sm:text-2xl text-foreground leading-snug">{s.title}</h3>
                <p className="mt-2 sm:mt-3 text-sm sm:text-base text-muted-foreground leading-relaxed">{s.body}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
